/**
 * Joins ARIA ID references while omitting unavailable IDs.
 * Returns undefined when no referenced element is present so the ARIA attribute is omitted.
 */
export const joinDescriptionIds = (...ids) => ids.filter(Boolean).join(' ') || undefined;
